import { MeterTypeState } from './types';

const state = (): MeterTypeState => {
  return {
    meterTypes: [],
  };
};

export default state;
